<ng-container *ngIf="(memberProfile$ | async).loaded">
  <ng-container *ngIf="(memberProfile$ | async).pay_with_points_card; else cardRegistration">
    <div class="description" *ngIf="showDescription">{{ 'PayWithPoints:Connected' | translate }}</div>
    <ten-pay-with-points-balance
      [points]="points"
      [fiatAmount]="fiatAmount"
      [fiatCurrency]="fiatCurrency"
      [profile]="profile"
      [showCurrencyEquivalent]="showCurrencyEquivalent"
    ></ten-pay-with-points-balance>
  </ng-container>
  <ng-template #cardRegistration>
    <div class="description">{{ 'PayWithPoints:AddCard' | translate }}</div>
    <form *ngIf="url.stringValue$ | async as url" class="add-card-form">
      <iframe
        #iframe
        [src]="url | safeUrl"
        title="Tokenizer"
        frameborder="0"
        aria-hidden="true"
        referrerpolicy="origin"
        tenTokenizerMessageListener
        (tokenizerMessage)="onMessage($event.data)"
        (load)="setCustomVariables()"
      ></iframe>
      <button mat-button class="add-card" [disabled]="!token" (accessibleClick)="addNewCard()">
        {{ 'PayWithPoints:AddCardCTA' | translate }}
      </button>
    </form>
  </ng-template>
</ng-container>
